module CostOfConstructionAttachmentModal

open FSharpPlus
open Model
open Fable.React
open Fable.React.Props
open PortalLibs.Client.Util
open Fulma
open ContractPageModel
open Fable.FontAwesome
open Shared
open PortalLibs.Shared

let attachmentsModal
  modalOpenOpt
  attachments
  attachmentPreview
  attachmentDownload
  attachmentContents
  attachmentsVisited
  dispatch
  =
  let preview attachmentOpt attachmentIdOpt contents dispatch =
    match attachmentIdOpt, attachmentOpt with
    | Some attachmentId, Some (attachment: JobCostDetailAttachment) ->
      div [] [
        loadingMessageOrContent
          "Loading file from the Vista Database..."
          (fun fileContent ->
            let fileUrl =
              $"/attachments/%s{attachment.Id.ToString()}/%s{attachment.OrigFileName |> Option.emptyStrIfNone}"

            div [ Style [ PaddingBottom "10px" ] ] [
              div [ Style [
                      Display DisplayOptions.Flex
                      JustifyContent "space-around"
                      OverflowY OverflowOptions.Auto
                      MaxHeight "600px"
                      MarginBottom "15px"
                    ] ] [
                div [ Style [
                        Display DisplayOptions.Flex
                        FlexDirection "column"
                        AlignItems AlignItemsOptions.Center
                        Width "100%"
                      ] ] [
                  strong [] [
                    attachment.OrigFileName
                    |> Option.emptyStrIfNone
                    |> sprintf "File Preview: %s"
                    |> str
                  ]
                  match fileContent with
                  | VistaNotAvailable ->
                    div [ Style [ Padding "50px 0" ] ] [
                      str "The connection to the Vista Database is currently unavailable."
                    ]
                  | Downloaded ->
                    div [ Style [
                            PaddingTop "10px"
                            Width "100%"
                          ] ] [
                      //iframe [ Src ("https://localhost:8080"+fileUrl) ] []
                      reactFileViewer fileUrl
                    ]
                ]
              ]
              div [ Style [
                      Display DisplayOptions.Flex
                      FlexDirection "row-reverse"
                      Width "100%"
                    ] ] [
                Button.button [ Button.OnClick(fun _ -> None |> PreviewAttachment |> dispatch) ] [
                  str "Close Preview"
                ]
                match fileContent with
                | Downloaded ->
                  a [ ClassName "button is-primary"
                      Href fileUrl
                      HTMLAttr.Download ""
                      Style [ MarginRight "15px" ] ] [
                    str "Download"
                  ]
                | VistaNotAvailable -> nothing
              ]
            ])
          (contents |> Map.tryFind attachmentId)
      ]
    | _, _ -> nothing

  let downloading (attachment: JobCostDetailAttachment option) contents =
    match attachment with
    | None -> nothing
    | Some attachment ->
      match Map.tryFind attachment.Id contents with
      | None ->
        div [ Style [
                Position PositionOptions.Relative
                Top "30%"
              ] ] [
          loadingWithElem
            (span [] [
              str $"File: %s{attachment.OrigFileName |> Option.emptyStrIfNone}"
              br []
              str "Downloading file from Vista..."
             ])
            IconSize.Large
        ]
      | Some fileContent ->
        match fileContent with
        | VistaNotAvailable ->
          div [ Style [
                  Display DisplayOptions.Flex
                  FlexDirection "column"
                  AlignItems AlignItemsOptions.Center
                ] ] [
            div [ Style [ Padding "50px 0" ] ] [
              str "The connection to the Vista Database is currently unavailable."
            ]
          ]
        | Downloaded -> nothing


  let rows items =
    items
    >>=
      (fun (_, attachmentsGroup) ->
        [ tr [ ClassName "tr-no-border tr-no-bottom-margin" ] [
            td [] [
              strong [] [
                match attachmentsGroup |> List.tryHead with
                | None -> nothing
                | Some item ->
                  (if (item.SourceItem |> Option.emptyStrIfNone).Trim()
                      <> "" then
                     $"%s{item.Source |> Option.emptyStrIfNone} - %s{item.SourceItem |> Option.emptyStrIfNone}"
                   else
                     (item.Source |> Option.emptyStrIfNone))
                  |> str
              ]
            ]
            td [] []
            td [] []
            td [] []
            td [] []
          ]
          yield!
            attachmentsGroup
            |> List.map
                 (fun attachment ->
                   tr [] [
                     td [] []
                     td [] [
                       a [ OnClick
                             (fun _ ->
                               attachment.Id
                               |> Some
                               |> PreviewAttachment
                               |> dispatch)
                           if attachmentsVisited
                              |> Map.containsKey attachment.Id then
                             Style [ Color "gray" ] ] [
                         attachment.OrigFileName |> emptyStrTagIfNone
                       ]
                     ]
                     td [] [
                       attachment.Description |> emptyStrTagIfNone
                     ]
                     td [] [
                       attachment.AddedBy |> emptyStrTagIfNone
                     ]
                     td [ Style [
                            TextAlign TextAlignOptions.Right
                          ] ] [
                       attachment.AddDate
                       |> prettyPrintDateOptionLong
                       |> str
                     ]
                     td [] [
                       a [ OnClick
                             (fun _ ->
                               attachment
                               |> Some
                               |> DownloadAttachment
                               |> dispatch) ] [
                         div [ Style [ PaddingBottom "2px" ] ] [
                           Icon.icon [ Icon.Props [
                                         Style [ Color "deepskyblue" ]
                                       ] ] [
                             Fa.i [ Fa.Solid.FileDownload ] []
                           ]
                         ]
                       ]
                     ]
                   ]) ])

  let items =
    modalOpenOpt
    >>=
      (fun (costId, detailId) ->
        attachments
        |> Map.tryFind costId
        >>= (fun attachmentMap -> attachmentMap |> Map.tryFind detailId))
    |> Option.defaultValue []
    |> List.groupBy (fun (attachment: JobCostDetailAttachment) -> attachment.UniqueAttachmentId)

  Modal.modal [ Modal.IsActive(Option.isSome modalOpenOpt) ] [
    Modal.background [ Props [
                         OnClick(fun _ -> None |> ShowAttachmentsModal |> dispatch)
                       ] ] []
    Modal.Card.card [ CustomClass "modal-card-wide"
                      Props [ Style [] ] ] [
      Modal.Card.head [] [
        Modal.Card.title [] [
          "Job Cost Detail Attachments" |> str
        ]
        Delete.delete [ Delete.OnClick(fun _ -> None |> ShowAttachmentsModal |> dispatch) ] []
      ]
      Modal.Card.body [] [
        div [ Id "ModalCardBody"
              Style [ Margin "-20px 0 20px 0" ] ] []
        div [] [
          preview
            (attachmentPreview
             >>=
                (fun attachmentId ->
                  items
                  |> List.tryFind
                       (fun (_, files) ->
                         List.exists (fun (item: JobCostDetailAttachment) -> item.Id = attachmentId) files)
                  >>= (fun (_, files) -> List.tryFind (fun item -> item.Id = attachmentId) files)))
            attachmentPreview
            attachmentContents
            dispatch

          downloading attachmentDownload attachmentContents

          Table.table [ Table.IsFullWidth; Table.IsHoverable ] [
            thead [] [
              tr [] [
                th [ Style [ VerticalAlign "middle" ] ] [
                  str "Source"
                ]
                th [ Style [ VerticalAlign "middle" ] ] [
                  str "File"
                ]
                th [ Style [ VerticalAlign "middle" ] ] [
                  str "Description"
                ]
                th [ Style [
                       VerticalAlign "middle"
                       Width "100px"
                     ] ] [
                  str "Added By"
                ]
                th [ Style [
                       TextAlign TextAlignOptions.Right
                       VerticalAlign "middle"
                       Width "135px"
                     ] ] [
                  str "Date"
                ]
                th [] []
              ]
            ]
            tbody [] (rows items)
          ]

        ]
      ]
      Modal.Card.foot [] [
        div [ Style [
                Display DisplayOptions.Flex
                FlexDirection "row-reverse"
                Width "100%"
              ] ] [
          Button.button [ Button.OnClick(fun _ -> None |> ShowAttachmentsModal |> dispatch) ] [
            str "Close"
          ]
        ]
      ]
    ]
  ]
